// import React, { useRef, useEffect } from 'react'
// import styled, { ThemeProvider } from 'styled-components'
// import { darkTheme } from "./Themes";
// import { motion } from 'framer-motion';

// import LogoComponent from "../subComponents/LogoComponent";
// import SocialIcons from "../subComponents/SocialIcons";
// import PowerButton from "../subComponents/PowerButton";

// import { Work } from '../data/WorkData';
// import Card from '../subComponents/Card';
// import { YinYang } from './AllSvgs';
// import BigTitle from '../subComponents/BigTitle';

// const Box = styled.div`
//   background-color: ${props => props.theme.body};
//   height: 800vh;
//   position: relative;
//   display: flex;
//   align-items: center;
// `;

// const Main = styled(motion.ul)`
//   position: fixed;
//   top: 12rem;
//   left: calc(6rem + 15vw);
//   height: 40vh;
//   display: flex;
//   color: white;
// `;

// const Rotate = styled.span`
//   display: block;
//   position: fixed;
//   right: 1rem;
//   bottom: 1rem;
//   width: 80px;
//   height: 80px;
//   z-index: 1;
// `;

// // Framer Motion Animation Variants
// const container = {
//   hidden: { opacity: 0 },
//   show: {
//     opacity: 1,
//     transition: {
//       staggerChildren: 0.5,
//       duration: 0.5,
//     }
//   }
// };

// // Exit Animation Variant
// const pageVariants = {
//   initial: { opacity: 0, y: -50 },
//   animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
//   exit: { opacity: 0, y: 50, transition: { duration: 0.5 } },
// };

// const WorkPage = () => {
//   const ref = useRef(null);
//   const yinyang = useRef(null);

//   useEffect(() => {
//     let element = ref.current;

//     const rotate = () => {
//       element.style.transform = `translateX(${-window.pageYOffset}px)`;
//       yinyang.current.style.transform = `rotate(${ -window.pageYOffset }deg)`;
//     };

//     window.addEventListener('scroll', rotate);
//     return () => window.removeEventListener('scroll', rotate);
//   }, []);

//   return (
//     <ThemeProvider theme={darkTheme}>
//       <motion.div
//         initial="initial"
//         animate="animate"
//         exit="exit"
//         variants={pageVariants}
//       >
//         <Box>
//           <LogoComponent theme='dark' />
//           <SocialIcons theme='dark' />
//           <PowerButton />
          
//           <Main ref={ref} variants={container} initial='hidden' animate='show'>
//             {Work.map(d => <Card key={d.id} data={d} />)}
//           </Main>

//           <Rotate ref={yinyang}>
//             <YinYang width={80} height={80} fill={darkTheme.text} />
//           </Rotate>

//           <BigTitle text="WORK" top='10%' right='20%' />
//         </Box>
//       </motion.div>
//     </ThemeProvider>
//   );
// };

// export default WorkPage;



import React, { useRef, useEffect } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { darkTheme } from "./Themes";
import { motion } from 'framer-motion';
import { useSearchParams } from 'react-router-dom';

import LogoComponent from "../subComponents/LogoComponent";
import SocialIcons from "../subComponents/SocialIcons";
import PowerButton from "../subComponents/PowerButton";

import { Work } from '../data/WorkData';
import { Research } from '../data/ResearchData';
import Card from '../subComponents/Card';
import { YinYang } from './AllSvgs';
import BigTitle from '../subComponents/BigTitle';
import ClassifiedNote, { FloatingHint } from '../subComponents/ClassifiedNote';

const Box = styled.div`
  background-color: ${props => props.theme.body};
  height: ${props => props.$height}vh;
  position: relative;
  display: flex;
  align-items: center;
`;

const Main = styled(motion.ul)`
  position: fixed;
  top: 12rem;
  left: calc(6rem + 15vw);
  height: 40vh;
  display: flex;
  color: white;
`;

const Rotate = styled.span`
  display: block;
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  width: 80px;
  height: 80px;
  z-index: 1;
`;

const Switch = styled.div`
  position: fixed;
  top: 2rem;
  right: 2rem;
  display: flex;
  gap: 0.5rem;
  z-index: 5;
  padding: 0.3rem;
  border: 1px solid ${props => props.theme.text};
  border-radius: 999px;
`;

const Tab = styled.button`
  position: relative;
  padding: 0.5rem 1.2rem;
  background: none;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.95rem;
  color: ${props => (props.$active ? props.theme.body : props.theme.text)};
  transition: color 0.3s ease;

  span { position: relative; z-index: 1; }

  @media (max-width: 600px) {
    padding: 0.4rem 0.8rem;
    font-size: 0.85rem;
  }
`;

const Pill = styled(motion.div)`
  position: absolute;
  inset: 0;
  background: ${props => props.theme.text};
  border-radius: 999px;
`;

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.5, duration: 0.5 }
  }
};

const pageVariants = {
  initial: { opacity: 0, y: -50 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  exit: { opacity: 0, y: 50, transition: { duration: 0.5 } },
};

const TABS = [
  { key: 'software', label: 'Software' },
  { key: 'research', label: 'Research' },
];

const WorkPage = () => {
  const ref = useRef(null);
  const yinyang = useRef(null);
  const [params, setParams] = useSearchParams();

  const category = params.get('tab') === 'research' ? 'research' : 'software';
  const items = category === 'research' ? Research : Work;

  // scroll length scales with number of cards instead of a fixed 800vh
  // const height = Math.max(300, items.length * 100 + 200);

  const showNote = category === 'software';
  const slots = items.length + (showNote ? 1 : 0);
  const height = Math.max(300, slots * 100 + 200);

  useEffect(() => {
    const element = ref.current;
    const spinner = yinyang.current;

    const rotate = () => {
      element.style.transform = `translateX(${-window.pageYOffset}px)`;
      spinner.style.transform = `rotate(${-window.pageYOffset}deg)`;
    };

    // reset position whenever the tab changes
    window.scrollTo(0, 0);
    rotate();

    window.addEventListener('scroll', rotate);
    return () => window.removeEventListener('scroll', rotate);
  }, [category]);

  const selectTab = (key) => setParams({ tab: key }, { replace: true });

  return (
    <ThemeProvider theme={darkTheme}>
      <motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants}>
        <Box $height={height}>
          <LogoComponent theme='dark' />
          <SocialIcons theme='dark' />
          <PowerButton />

          <Switch>
            {TABS.map(t => (
              <Tab key={t.key} $active={category === t.key} onClick={() => selectTab(t.key)}>
                {category === t.key && <Pill layoutId="tab-pill" />}
                <span>{t.label}</span>
              </Tab>
            ))}
          </Switch>

          {/* key forces a remount so the stagger animation replays on switch */}
          <Main key={category} ref={ref} variants={container} initial='hidden' animate='show'>
            {items.map(d => <Card key={d.id} data={d} />)}
            {showNote && <ClassifiedNote contact="mailto:ndiyoedward@email.com" />}
          </Main>

          {showNote && <FloatingHint />}

          <Rotate ref={yinyang}>
            <YinYang width={80} height={80} fill={darkTheme.text} />
          </Rotate>

          <BigTitle text={category === 'research' ? 'RESEARCH' : 'WORK'} top='10%' right='20%' />
        </Box>
      </motion.div>
    </ThemeProvider>
  );
};

export default WorkPage;